function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("g", {
  "data-name": "Layer 3"
}, React.createElement("path", {
  d: "M1856 206.13l-.23 101-.52 114H0V103.51c0-9.63 6.29-18.37 15.61-20.79q.59-.15 1.2-.27a21.16 21.16 0 0112.63 1.32A21.63 21.63 0 0047.87 83L202.49 2.43a21.6 21.6 0 0121.84 1.12l154.1 101.63a21.58 21.58 0 007 3l226.11 52.32a21.47 21.47 0 0010.1-.08l107.73-27a21.57 21.57 0 0115 1.7l120.73 61.67 97.84 50a21.67 21.67 0 006.44 2.09c38.8 6.11 398 62.57 405.41 59.82C1382 306 1485.5 204.19 1501.94 188a21.38 21.38 0 014.89-3.62l6.58-3.54 169.65-91.34a21.57 21.57 0 0122.74 1.5l141.15 97.82a21.5 21.5 0 019.05 17.31z",
  fill: "#eaedf2"
}), React.createElement("path", {
  d: "M1856 300.12v121H0V62.23L16.81 72.5l232.47 142a19.76 19.76 0 008.41 2.82l202.61 20a20.33 20.33 0 016.63 1.86L609 307.22a19.88 19.88 0 0018-.44L801.18 213a18 18 0 012-.93l62-25.18 84.07-34.17a19.81 19.81 0 0110.42-1.24L1097 171.93a19.88 19.88 0 0012.18-2.07l78.15-40.94a19.73 19.73 0 004.62-3.35l109.41-106a19.9 19.9 0 0126.48-1.08l185.56 152.44 100 82.18a18.92 18.92 0 003.4 2.26l70.55 36.88a19.94 19.94 0 0019.42-.56l72.57-43.32a19.9 19.9 0 0122.09 1.14l46.57 34.66a19.74 19.74 0 017.77 13 18.65 18.65 0 01.23 2.95z",
  fill: "#f5f8fc"
})));

var SvgBespokenMountains = function SvgBespokenMountains(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 1856 421.15"
  }, props), _ref);
};

export default SvgBespokenMountains;